import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import limparUltimosHistoricosPreco from '../../actions/preco/limparUltimosHistoricosPreco';
import { formatarReal } from '../../util/numberUtil';

export const Cabecalho = () => (
    <div className="lista-eventos titulo">
      <div className="row cabecalho-desktop" style={{ fontWeight: 'bold'}}>
        <div className="col-12 col-sm-12 col-md">Data e Hora</div>
        <div className="col-12 col-sm-12 col-md">Situação</div>
        <div className="col-12 col-sm-12 col-md">Usuário</div>        
        <div className="col-12 col-sm-12 col-md">Cidade Origem</div>
        <div className="col-12 col-sm-12 col-md">Cidade Destino</div>
        <div className="col-12 col-sm-12 col-md">Tipo veículo</div>
        <div className="col-12 col-sm-12 col-md">Valor</div>
        <div className="col-12 col-sm-12 col-md">Valor ANTT</div>
        <div className="col-12 col-sm-12 col-md">Tarifa do Seguro</div>        
      </div>
    </div>
  );


export class ModalHistoricoPrecos extends Component {

    fecharModal () {
        $('#modalHistoricoPrecos')
            .modal('hide');
        $('#modalHistoricoPrecos')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.limparUltimosHistoricosPreco();
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => <div className="lista-eventos" key={`${historico.id}-${historico.dataEvento}`}>
              <div className="row conteudo-desktop">
                <div className="col-12 col-sm-12 col-md">
                  <Moment 
                      format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="usuario" className="texto">
                    <p>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</p>
                  </div>
                </div>              
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{historico.preco.cidadeOrigem.nomeComUf}</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{historico.preco.cidadeDestino.nomeComUf}</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{historico.preco.descricaoTipoPreco ? capitalizarTodasPrimeirasLetras(historico.preco.descricaoTipoPreco) : capitalizarTodasPrimeirasLetras(historico.preco.tipoPreco)}</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{formatarReal(historico.preco.valor)}</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{formatarReal(historico.preco.valorAntt)}</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md">
                  <div id="evento" className="texto">
                    <p>{historico.preco.tarifaSeguro ? formatarReal(historico.preco.tarifaSeguro) : ''}</p>
                  </div>
                </div>                
              </div>
            </div>)
          }
          return ''
    }

    render() {
        return (
            <div className="modal fade show" id='modalHistoricoPrecos' role='dialog'
                aria-labelledby='modalHistoricoPrecos' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Histórico Preços </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons" onClick={() => this.fecharModal()}>
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <Cabecalho />
                            {this.exibirHistoricos()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


export const mapStateToProps = (state) => {
    return {
        empresaSelecionada: state.empresaSelecionada,
        historicos: state.ultimosHistoricosPreco
    }
};

export default connect(mapStateToProps, {
    limparUltimosHistoricosPreco
})(ModalHistoricoPrecos)